"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var core_2 = require("@react-pdf-viewer/core");
var react_router_dom_1 = require("react-router-dom");
var react_share_1 = require("react-share");
var default_layout_1 = require("@react-pdf-viewer/default-layout");
var Facebook_1 = __importDefault(require("@mui/icons-material/Facebook"));
var Telegram_1 = __importDefault(require("@mui/icons-material/Telegram"));
var ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
var environment_variables_1 = require("../../shared/util/environment-variables");
require("@react-pdf-viewer/core/lib/styles/index.css");
require("@react-pdf-viewer/default-layout/lib/styles/index.css");
require("@react-pdf-viewer/toolbar/lib/styles/index.css");
require("./styles.scss");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        header: (_a = {
                flexGrow: 1,
                flexShrink: 0,
                marginRight: 20,
                marginTop: theme.spacing(4),
                whiteSpace: 'nowrap',
                textAlign: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                order: 10,
                flexBasis: '100%',
                marginTop: theme.spacing(3),
            },
            _a),
        // content: {
        //   fontSize: 16,
        //   padding: `${theme.spacing(5)}px ${theme.spacing(10)}px`,
        //   [theme.breakpoints.down('sm')]: {
        //     padding: `${theme.spacing(3)}px 0`,
        //   },
        // },
        renderError: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
        },
        shareIcon: {},
    });
});
/**
 * Show the privacy and policy page.
 */
var FileViewerPage = function () {
    var classes = useStyles();
    var search = react_router_dom_1.useLocation().search;
    var searchParams = react_1.useMemo(function () { return new URLSearchParams(search); }, [search]);
    var _a = __read(react_1.useState(''), 2), url = _a[0], setUrl = _a[1];
    var _b = __read(react_1.useState(false), 2), hasError = _b[0], setHasError = _b[1];
    var _c = __read(react_1.useState(false), 2), copied = _c[0], setCopied = _c[1];
    var frontEndUrlEnv = environment_variables_1.ddEnv === 'production' ? 'https://go.gov.kh' : 'https://dev.go.gov.kh';
    var awsUrlEnv = environment_variables_1.ddEnv === 'production'
        ? 'https://file.go.gov.kh'
        : 'https://file.dev.go.gov.kh';
    var fileUrl = frontEndUrlEnv + "/" + url.replace('.pdf', '');
    var transform = function (slot) { return (__assign(__assign({}, slot), { 
        // These slots will be empty
        Open: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, OpenMenuItem: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, Rotate: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, RotateBackwardMenuItem: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, RotateForwardMenuItem: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, SwitchTheme: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, SwitchThemeMenuItem: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, Search: function () { return react_1.default.createElement(react_1.default.Fragment, null); }, ShowSearchPopover: function () { return react_1.default.createElement(react_1.default.Fragment, null); } })); };
    var renderToolbar = function (Toolbar) { return react_1.default.createElement(Toolbar, null, renderDefaultToolbar(transform)); };
    var defaultLayoutPluginInstance = default_layout_1.defaultLayoutPlugin({
        renderToolbar: renderToolbar,
    });
    var renderDefaultToolbar = defaultLayoutPluginInstance.toolbarPluginInstance.renderDefaultToolbar;
    react_1.useEffect(function () {
        var urlQuery = searchParams.get('url') || '';
        setUrl(urlQuery);
    }, [searchParams]);
    var renderError = function (error) {
        var message = '';
        setHasError(true);
        switch (error.name) {
            case 'InvalidPDFException':
                message = 'The document is invalid or corrupted';
                break;
            case 'MissingPDFException':
                message = 'The document is missing';
                break;
            case 'UnexpectedResponseException':
                message = 'Unexpected server response';
                break;
            default:
                message = 'Cannot load the document';
                break;
        }
        return react_1.default.createElement("div", { className: classes.renderError }, message);
    };
    var copy = function () {
        var el = document.createElement('input');
        el.value = fileUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setCopied(true);
    };
    return (react_1.default.createElement(core_1.Grid
    // className={classes.content}
    , { 
        // className={classes.content}
        container: true, direction: "column", justifyContent: "center", alignItems: "center" },
        !hasError && (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "space-between" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { align: "left", component: "span" },
                    fileUrl,
                    react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: function () { return setCopied(false); } },
                        react_1.default.createElement(core_1.Tooltip, { title: copied ? 'copied' : '', open: copied },
                            react_1.default.createElement(core_1.IconButton
                            // style={{ color: '#42A5F5' }}
                            , { 
                                // style={{ color: '#42A5F5' }}
                                className: classes.shareIcon, onClick: copy },
                                react_1.default.createElement(ContentCopy_1.default, { fontSize: "small" })))))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { component: "span" }, "Share: "),
                react_1.default.createElement(core_1.Typography, { align: "right", component: "span" },
                    react_1.default.createElement(react_share_1.FacebookShareButton, { url: fileUrl },
                        react_1.default.createElement(core_1.IconButton, { style: { color: '#316FF6' } },
                            react_1.default.createElement(Facebook_1.default, { fontSize: "small" }))),
                    react_1.default.createElement(react_share_1.TelegramShareButton, { url: fileUrl, className: classes.shareIcon },
                        react_1.default.createElement(core_1.IconButton, { style: { color: '#0088cc' } },
                            react_1.default.createElement(Telegram_1.default, { fontSize: "small" }))))))),
        react_1.default.createElement(core_2.Worker, { workerUrl: "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.js" },
            react_1.default.createElement(core_2.Viewer, { defaultScale: core_2.SpecialZoomLevel.PageWidth, fileUrl: awsUrlEnv + "/" + url, renderError: renderError, plugins: [defaultLayoutPluginInstance] }))));
};
exports.default = FileViewerPage;
